import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
//primereact
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Accordion, AccordionTab } from "primereact/accordion";
//components
import Modal from "../../../../components/modal/Modal";
import CardPlan from "../../../../components/cards/CardPlan";
import CreditCard from "../../../../components/payment/CreditCard";
import CarouselPlans from "../../../../components/Carousel/CarouselPlans";
import PaymentMethods from "../../../../components/payment/PaymentMethods";
import ModalClientData from "../../../../components/payment/ModalClientData";
import ModalPixPayment from "../../../../components/payment/ModalPixPayment";
import ResumeActivation from "./ResumeActivation";
//services
import { getPlans } from "../../../../services/CreateAccount/getPlans";
import { getDueDate } from "../../../../services/CreateAccount/getDueDate";
import { getContractInterval } from "../../../../services/CreateAccount/getContractInterval";
// import { getUserOpenPayments } from "../../../services/ClientArea/getUserOpenPayments";
//context
import { useRegisterCompletedContext } from "../RegisterCompletedContext";
import Input from "../../../../components/input/Input";
import ReactInputMask from "react-input-mask";
import { api } from "../../../../utils/api";

const ModalActivationPlan = ({ visible, setVisible }) => {
  const navigate = useNavigate();
  const [errorUser, setErrorUser] = useState([false]);
  const [signatories, setSignatories] = useState([{}]);
  const [loadingCupom, setLoadingCupom] = useState(false);
  const [visibleDiscount, setVisibleDiscount] = useState(false);
  const {
    plan,
    form,
    cupom,
    formPix,
    setPlan,
    bestDay,
    setCupom,
    pixClient,
    pixDataQR,
    cardState,
    setBestDay,
    sortedData,
    activeIndex,
    cardMonthly,
    optionsDays,
    onSubmitPix,
    baseDataForm,
    handleSubmit,
    typeInterval,
    setPixClient,
    setPixDataQR,
    setCardState,
    appliedCoupon,
    validateCupom,
    loadingButton,
    setSortedData,
    paymentMethod,
    setOptionsDays,
    disabledButton,
    setActiveIndex,
    setCardMonthly,
    setTypeInterval,
    setBaseDataForm,
    cardInstallment,
    setLoadingButton,
    selectedInterval,
    activeIndexModal,
    creditCardClient,
    loadingIntervals,
    handleInputFocus,
    setPaymentMethod,
    visibleIntervals,
    baseDataIntervals,
    handleInputChange,
    setDisabledButton,
    visibleCreditCard,
    visiblePixPayment,
    creditCardSelected,
    handleMonthlyFocus,
    setCardInstallment,
    setActiveIndexModal,
    setCreditCardClient,
    handleMonthlyChange,
    setLoadingIntervals,
    optionsInstallments,
    setSelectedInterval,
    setVisibleIntervals,
    setBaseDataIntervals,
    setVisibleCreditCard,
    setVisiblePixPayment,
    setCreditCardSelected,
    visiblePaymentMethods,
    setOptionsInstallments,
    handleInstallmentFocus,
    handleRetryPaymentYear,
    visibleModalCreditCard,
    handleInstallmentChange,
    handleRetryPaymentMonth,
    setVisiblePaymentMethods,
    handleSelectPaymentMethod,
    setVisibleModalCreditCard,
  } = useRegisterCompletedContext();

  const steps = [
    { label: "Assinatura" },
    { label: "Plano" },
    { label: "Pagamento" },
  ];

  const { data: dueDates } = useQuery({
    queryKey: ["dueDate"],
    queryFn: () => getDueDate(),
  });

  const { data: plans, isLoading } = useQuery({
    queryKey: ["plans"],
    queryFn: () => getPlans(),
  });

  const savePlan = async (plan) => {
    // console.log(plan);
    setBestDay(null);

    setPlan(plan);
    if (plan.interval.interval === "month")
      setTypeInterval({ type: "month", id: plan.interval.id });
    if (plan.interval.interval === "year")
      setTypeInterval({ type: "year", id: plan.interval.id });
    try {
      await getContractInterval(plan.plan.id, plan.interval.id);
      // setActiveIndex(2);
    } catch (error) {
      // toast.error("Oops algo deu errado! Tente novamente, ou escolha outro plano.");
      // console.log(error.message);
    }
    setActiveIndex(2);
  };

  const onSubmit = async (data) => {
    setBaseDataForm(data);
    setActiveIndex(1);
  };

  const handleClickInterval = async (interval) => {
    setSelectedInterval(interval);
    setLoadingIntervals(true);
    //    console.log(interval)
    await savePlan({
      plan: baseDataIntervals,
      interval: interval,
    });
    setVisibleIntervals(false);
    setLoadingIntervals(false);
  };

  const handleAddSignatory = () => {
    setSignatories([...signatories, {}]);
    setErrorUser([...errorUser, false]);
  };

  const handleRemoveSignatory = (index) => {
    setSignatories((prevSignatory) =>
      prevSignatory.filter((_, i) => i !== index)
    );
    setErrorUser((prevError) => prevError.filter((_, i) => i !== index));
  };

  async function handleDoc(doc, type, index) {
    const data = {
      doc: doc,
      type: type,
    };
    try {
      const response = await api.post("check-doc", data);
      if (response.data.doc_valid === false) {
        if (type === "environment") {
          // setErrorEnvironment("Documento Inválido");
          form.setError("doc_enterprise", {
            type: "manual",
            message: "Documento Inválido",
          });
        }
        if (type === "user") {
          const errors = [...errorUser];
          errors[index] = true;
          setErrorUser(errors);
        }
      } else {
        if (response.data.exists) {
          if (type === "environment") {
            // setErrorEnvironment("Documento ja cadastrado na Lote Mobile");
            form.setError("doc_enterprise", {
              type: "manual",
              message: "Documento ja cadastrado na Lote Mobile",
            });
          } else {
            const errors = [...errorUser];
            errors[index] = false;
            setErrorUser(errors);
          }
        } else {
          if (type === "environment") {
            // setErrorEnvironment(null);
            form.clearErrors("doc_enterprise");
          }
          if (type === "user") {
            const errors = [...errorUser];
            errors[index] = false;
            setErrorUser(errors);
          }
        }
      }
    } catch (e) {
      if (type === "environment") {
        // setErrorEnvironment("Documento Inválido");
        form.setError("doc_enterprise", {
          type: "manual",
          message: "Documento Inválido",
        });
      }
      if (type === "user") {
        const errors = [...errorUser];
        errors[index] = true;
        setErrorUser(errors);
      }
    }
  }

  const templateDays = (option) => {
    return <h5>{option.value}</h5>;
  };

  const handleSelect = (data) => {
    console.log(data);
    const sortedIntervals = data.intervals.sort((a, b) => {
      if (a.interval === "month" && b.interval === "year") return -1;
      if (a.interval === "year" && b.interval === "month") return 1;
      if (a.interval === "month" && b.interval === "month")
        return a.interval_count - b.interval_count;
      if (a.interval === "year" && b.interval === "year")
        return a.interval_count - b.interval_count;
      return 0;
    });

    let maxYearInterval = null;

    sortedIntervals.forEach((interval) => {
      if (interval.interval === "year") {
        if (
          !maxYearInterval ||
          interval.interval_count > maxYearInterval.interval_count
        ) {
          maxYearInterval = interval;
        }
      }
    });

    if (maxYearInterval) {
      maxYearInterval.isLongestYearInterval = true;
    }

    data.intervals = sortedIntervals;

    setBaseDataIntervals(data);
    setVisibleIntervals(true);
  };

  useEffect(() => {
    const testDisabledButton = () => {
      const isCardStateEmpty = Object.values(cardState).some(
        (value) => value === ""
      );
      const isPixClientNull = pixClient === null;
      const isCardInstallmentEmpty = Object.values(cardInstallment).some(
        (value) => value === ""
      );
      const isCardMonthlyEmpty = Object.values(cardMonthly).some(
        (value) => value === ""
      );

      if (
        plan?.interval?.interval === "year" ||
        (plan?.intervals?.length > 0 && plan?.intervals[0]?.interval === "year")
      ) {
        if (
          (isCardStateEmpty && isPixClientNull && isCardInstallmentEmpty) ||
          paymentMethod === null
        ) {
          setDisabledButton(true);
        } else {
          setDisabledButton(false);
        }
      } else {
        if (!isPixClientNull && isCardMonthlyEmpty) {
          setDisabledButton(true);
        } else if (
          (isCardStateEmpty &&
            isPixClientNull &&
            isCardInstallmentEmpty &&
            isCardMonthlyEmpty) ||
          paymentMethod === null ||
          !bestDay
        ) {
          setDisabledButton(true);
        } else {
          setDisabledButton(false);
        }
      }
    };
    testDisabledButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cardState,
    cardInstallment,
    cardMonthly,
    pixClient,
    paymentMethod,
    bestDay,
  ]);

  useEffect(() => {
    if (dueDates) {
      const newOptions = dueDates.map((d) => ({
        value: d.due_date,
      }));
      setOptionsDays(newOptions);
    }
  }, [dueDates]);

  useEffect(() => {
    const sortPlans = (plans) => {
      return plans.sort((a, b) => (b.highlighted === 1 ? 1 : -1));
    };

    setSortedData(plans ? { ...plans, data: sortPlans(plans.plans) } : plans);
  }, [plans]);

  return (
    <>
      <Modal
        visible={visible}
        dynamicTitle={"Escolha de plano"}
        onHide={() => setVisible(false)}
        dynamicWidth={window.innerWidth <= 992 ? "90vw" : "85vw"}
        closable={true}
      >
        <>
          <Steps
            model={steps}
            className="mt-2 mb-4"
            activeIndex={activeIndex}
            onSelect={(e) => setActiveIndex(e.index)}
            readOnly={false}
          />

          {activeIndex === 0 && (
            <>
              <div className="row text-center justify-content-center">
                <h2>Informe os signatários do contrato</h2>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                  {signatories.map((_, index) => (
                    <div key={index} className="row justify-content-center">
                      <div className="col-md-3 mb-2 mb-md-0">
                        <Input
                          isRequired
                          type="text"
                          control={form.control}
                          errors={form.formState.errors}
                          label="Nome Completo*"
                          name={`name[${index}]`}
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-3">
                        <ReactInputMask
                          required
                          mask="999.999.999-99"
                          maskChar={null}
                          {...form.register(`doc[${index}]`)}
                          onBlur={(e) =>
                            handleDoc(e.target.value, "user", index)
                          }
                          placeholder="CPF *"
                          className={`input-cpf mt-4 ${
                            errorUser[index] ? "input-error" : ""
                          }`}
                        />
                        {errorUser[index] && (
                          <span className="p-error">Documento Inválido</span>
                        )}
                      </div>
                      <div className="col-md-3 mb-3">
                        <Input
                          isRequired
                          name={`email[${index}]`}
                          errors={form.formState.errors}
                          control={form.control}
                          type="email"
                          validationRules={{
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "E-mail inválido.",
                            },
                          }}
                          label="E-mail *"
                        />
                      </div>
                      <div className="col-md-1 mt-4">
                        {index > 0 && (
                          <Button
                            rounded
                            outlined
                            type="button"
                            severity="danger"
                            icon="fa fa-minus"
                            onClick={() => handleRemoveSignatory(index)}
                            style={{
                              width: "2rem",
                              height: "2rem",
                              padding: "2px",
                            }}
                          />
                        )}
                        {index === signatories.length - 1 && (
                          <Button
                            rounded
                            outlined
                            type="button"
                            size="small"
                            severity="info"
                            icon="fa fa-plus"
                            onClick={handleAddSignatory}
                            className="mx-2"
                            style={{
                              width: "2rem",
                              height: "2rem",
                              padding: "2px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="row justify-content-end">
                    <div className="col-md-2">
                      <Button
                        type="submit"
                        label="Próximo"
                        className="w-100"
                        icon="fa fa-arrow-right"
                        iconPos="right"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </>
          )}

          {activeIndex === 1 && (
            <>
              <div className="row text-center justify-content-center">
                <h2>Selecione um plano</h2>
                {sortedData?.plans.length > 4 ? (
                  <CarouselPlans
                    data={plans}
                    savePlan={savePlan}
                    options={{ loop: true }}
                    handleSelect={handleSelect}
                    quantity={sortedData?.plans.length}
                  />
                ) : (
                  <div className="row py-3" data-bs-theme="dark">
                    {sortedData?.plans?.map((plan) => {
                      if (plan.free_trial_days) {
                        return;
                      }
                      return (
                        <CardPlan
                          plan={plan}
                          savePlan={savePlan}
                          handleSelect={handleSelect}
                          modules={sortedData?.modules}
                          quantity={sortedData?.plans.length}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </>
          )}

          {activeIndex === 2 && (
            <>
              <div className="row text-center justify-content-center mb-4">
                <h2>Selecione a forma de pagamento</h2>
                <div className="my-5">
                  <div className="row justify-content-around">
                    <div
                      className={`col-xl-6 col-md-7 ${
                        typeInterval.type !== "month" ? "my-auto" : ""
                      }`}
                      style={
                        typeInterval.type !== "month"
                          ? { height: "fit-content" }
                          : {}
                      }
                    >
                      {typeInterval.type === "month" ? (
                        <Accordion activeIndex={0}>
                          <AccordionTab header="Adesão">
                            <PaymentMethods
                              pix
                              card
                              installment
                              form={form}
                              formPix={formPix}
                              cardState={cardState}
                              onSubmitPix={onSubmitPix}
                              paymentMethod={paymentMethod}
                              setCardMonthly={setCardMonthly}
                              cardInstallment={cardInstallment}
                              setPaymentMethod={setPaymentMethod}
                              handleInputFocus={handleInputFocus}
                              creditCardClient={creditCardClient}
                              handleInputChange={handleInputChange}
                              visibleCreditCard={visibleCreditCard}
                              setCardInstallment={setCardInstallment}
                              handleMonthlyFocus={handleMonthlyFocus}
                              creditCardSelected={creditCardSelected}
                              setActiveIndexModal={setActiveIndexModal}
                              setCreditCardClient={setCreditCardClient}
                              optionsInstallments={optionsInstallments}
                              setVisibleCreditCard={setVisibleCreditCard}
                              setCreditCardSelected={setCreditCardSelected}
                              visiblePaymentMethods={visiblePaymentMethods}
                              handleInstallmentFocus={handleInstallmentFocus}
                              handleInstallmentChange={handleInstallmentChange}
                              setVisiblePaymentMethods={
                                setVisiblePaymentMethods
                              }
                              setVisibleModalCreditCard={
                                setVisibleModalCreditCard
                              }
                              handleSelectPaymentMethod={
                                handleSelectPaymentMethod
                              }
                            />
                          </AccordionTab>
                          <AccordionTab header="Mensalidade">
                            <>
                              <div className="d-flex flex-column text-center justify-content-center mb-5">
                                <h4>
                                  Qual o melhor dia do mês para sua mensalidade?
                                </h4>
                                <SelectButton
                                  value={bestDay}
                                  onChange={(e) => setBestDay(e.value)}
                                  itemTemplate={templateDays}
                                  optionLabel="value"
                                  options={optionsDays}
                                />
                              </div>
                              {/* {bestDay && (
                                <CreditCard
                                  completed={paymentMethod !== "pix"}
                                  state={cardMonthly}
                                  handleInputChange={handleMonthlyChange}
                                  handleInputFocus={handleMonthlyFocus}
                                  onClickData={() => {
                                    setVisibleModalCreditCard(true);
                                    setActiveIndexModal(0);
                                  }}
                                  onClickAddress={() => {
                                    setVisibleModalCreditCard(true);
                                    setActiveIndexModal(1);
                                  }}
                                  clientData={
                                    creditCardClient?.data &&
                                    creditCardClient?.data
                                  }
                                  clientAddress={
                                    creditCardClient?.address &&
                                    creditCardClient?.address
                                  }
                                />
                              )} */}
                            </>
                          </AccordionTab>
                        </Accordion>
                      ) : (
                        <div className="h-100">
                          <PaymentMethods
                            pix
                            card
                            installment
                            form={form}
                            formPix={formPix}
                            cardState={cardState}
                            onSubmitPix={onSubmitPix}
                            paymentMethod={paymentMethod}
                            setCardMonthly={setCardMonthly}
                            cardInstallment={cardInstallment}
                            setPaymentMethod={setPaymentMethod}
                            handleInputFocus={handleInputFocus}
                            creditCardClient={creditCardClient}
                            handleInputChange={handleInputChange}
                            visibleCreditCard={visibleCreditCard}
                            setCardInstallment={setCardInstallment}
                            handleMonthlyFocus={handleMonthlyFocus}
                            creditCardSelected={creditCardSelected}
                            setActiveIndexModal={setActiveIndexModal}
                            setCreditCardClient={setCreditCardClient}
                            optionsInstallments={optionsInstallments}
                            setVisibleCreditCard={setVisibleCreditCard}
                            setCreditCardSelected={setCreditCardSelected}
                            visiblePaymentMethods={visiblePaymentMethods}
                            handleInstallmentFocus={handleInstallmentFocus}
                            handleInstallmentChange={handleInstallmentChange}
                            setVisiblePaymentMethods={setVisiblePaymentMethods}
                            setVisibleModalCreditCard={
                              setVisibleModalCreditCard
                            }
                            handleSelectPaymentMethod={
                              handleSelectPaymentMethod
                            }
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-5">
                      <ResumeActivation
                        plan={plan}
                        form={form}
                        cupom={cupom}
                        bestDay={bestDay}
                        setCupom={setCupom}
                        loadingButton={loadingButton}
                        handleSubmit={handleSubmit}
                        loadingCupom={loadingCupom}
                        appliedCoupon={appliedCoupon}
                        validateCupom={validateCupom}
                        visibleDiscount={visibleDiscount}
                        setLoadingCupom={setLoadingCupom}
                        setVisibleDiscount={setVisibleDiscount}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      </Modal>

      <Modal
        visible={visibleIntervals}
        dynamicTitle="Opções do Plano"
        onHide={() => {
          setBaseDataIntervals();
          setVisibleIntervals(false);
        }}
        closable={true}
      >
        <div className="row">
          {baseDataIntervals &&
            baseDataIntervals.intervals.map((i, index) => (
              <div
                key={index}
                className={`col-xl-6 col-md-6 py-3 pricing-card`}
                // className={`col-xl-3 col-md-6 py-3 h-100 pricing-card ${
                //   plan.highlighted === 0 ? "py-xl-5" : ""
                // }`}
              >
                <div
                  className={`card bg-dark-400 border-0 rounded-4 h-100`}
                  style={
                    i.isLongestYearInterval
                      ? {
                          background:
                            "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,185,167,1) 0%, rgba(114,212,202,1) 100%)",
                          overflow: "hidden",
                        }
                      : {}
                  }
                >
                  <div className="card-body fs-14px p-30px d-flex flex-column position-relative">
                    {/* {!user && plan.highlighted === 1 && (
                        <div className="ribbon">Mais Vendido!</div>
                      )} */}
                    <div className="d-flex align-items-center">
                      <div className="flex-1">
                        <div className="h5 text-white font-monospace">
                          {i.name}
                        </div>
                        {i.pivot.discount_rate > 0 ? (
                          <div className="d-flex align-items-center">
                            <small className="h5 mt-2 text-gray-100 text-opacity-50">
                              <s>R$ {baseDataIntervals.value_total}</s>
                            </small>
                            <div className="bg-white rounded-pill fw-bold py-1 px-3 mx-2">
                              Economize {i.pivot.discount_rate * 100}%
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <small
                              className="h5 mt-2 text-gray-100 text-opacity-0"
                              style={{ visibility: "hidden" }}
                            >
                              <s>R$ {baseDataIntervals.value_total}</s>
                            </small>
                            <div
                              className="bg-white rounded-pill fw-bold py-1 px-3 mx-2"
                              style={{ visibility: "hidden" }}
                            >
                              Economize 0%
                            </div>
                          </div>
                        )}
                        <div className="display-6 text-white fw-bold mb-0">
                          {baseDataIntervals.free_trial_days ? (
                            <>
                              GRÁTIS{" "}
                              <small className="h5 text-gray-100 text-opacity-50">
                                por 30 dias
                              </small>
                            </>
                          ) : (
                            <>
                              R${" "}
                              {baseDataIntervals.value_total -
                                baseDataIntervals.value_total *
                                  i.pivot.discount_rate}{" "}
                              <small className="h5 text-gray-100 text-opacity-50">
                                /mês*
                              </small>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mx-n2 mt-3">
                      <Button
                        label="Assinar"
                        disabled={loadingIntervals}
                        onClick={() => handleClickInterval(i)}
                        loading={
                          i.id === selectedInterval?.id && loadingIntervals
                        }
                        className="w-100 text-black border border-0 button-card"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Modal>

      <ModalClientData
        baseDataForm={baseDataForm}
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        setActiveIndex={setActiveIndexModal}
        creditCardClient={creditCardClient}
        setVisible={setVisibleModalCreditCard}
        setCreditCardClient={setCreditCardClient}
      />

      <ModalPixPayment
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        onContinue={() => {
          setVisiblePixPayment(false);
          setVisible(false);
          navigate("/success", {
            state: {
              pixPayment: true,
              idPayment: pixDataQR.id ? pixDataQR.id : "",
            },
          });
        }}
      />
    </>
  );
};

export default ModalActivationPlan;
